import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["prefectureSelect", "addressInput"];

  async fill(event) {
    const postalCode = this.normalizePostalCodeInput(event.target.value);

    if (postalCode === null) {
      return;
    }

    const response = await get(
      `/api/postal_codes/${encodeURIComponent(postalCode)}`
    );

    if (!response.ok) {
      console.error(response);
      return;
    }

    const address = await response.json;

    this.prefectureSelectTarget.value = address.prefecture_code;
    this.addressInputTarget.value = [address.city, address.town].join("");
  }

  normalizePostalCodeInput(input) {
    const postalCode = input
      .trim()
      .replaceAll(/[０-９]/g, (match) => {
        // 全角数字 → 半角数字
        return String.fromCharCode(match.charCodeAt(0) - 0xfee0);
      })
      .replaceAll("-", "")
      .replaceAll("−", "");

    return postalCode.length === 7 ? postalCode : null;
  }
}
